const VUE_NO_UPLOADER_START_CLICK = 'vue-no-upload-start-click';

export { VUE_NO_UPLOADER_START_CLICK };
